// src/redux/services/authService/authApi.js
import axiosInstance from "../../apiAxios/axiosInstance";

// ✅ Login API
export const loginAdmin = async (loginData) => {
  const response = await axiosInstance.post("/login", loginData);
  return response.data;
};

// ✅ Get Admin Profile
export const getAdminProfile = async () => {
  const response = await axiosInstance.get("/admin-profile");
  return response.data;
};